const webPackage = require('./package.json')

function getSentryRelease(packageInfo = webPackage) {
  return `${packageInfo.name}_web@${packageInfo.version}`
}

module.exports = { getSentryRelease }
